import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './Payments.module.css';
import { Button } from '../../components/ui/Button';
import { DialogHelp } from '../../help/DialogHelp';

export function PartnerBillDialog({ initialValue, onCancel, onSubmit, submitting = false, error = null }: {
  initialValue: string;
  onCancel: () => void;
  onSubmit: (billNumber: string) => void | Promise<void>;
  submitting?: boolean;
  /** Plain-language save failure, shown above the actions; the typed number stays. */
  error?: string | null;
}) {
  const { t } = useTranslation();
  const [value, setValue] = useState(initialValue);
  const billNumber = value.trim();
  const valid = billNumber.length >= 1 && billNumber.length <= 40;
  return <div className={styles.scrim}><section role="dialog" aria-modal="true" aria-label={t('payments.partnerBillDialog.title')} className={`${styles.dialog} ${styles.compact}`}>
    <header className={styles.header}><h2>{t('payments.partnerBillDialog.title')}</h2><DialogHelp context="partner-bill" title={t('payments.partnerBillDialog.title')} /></header>
    <div className={styles.body}><label className={styles.field}>{t('payments.partnerBillDialog.title')}<input aria-label={t('payments.partnerBillDialog.title')} maxLength={40} value={value} onChange={(event) => setValue(event.target.value)} /></label>
      {error && <div role="alert" className={styles.error}>{error}</div>}
      <div className={styles.actions}><Button variant="secondary" size="sm" disabled={submitting} onClick={onCancel}>{t('common.actions.cancel')}</Button><Button variant="primary" size="sm" disabled={!valid || submitting} onClick={() => onSubmit(billNumber)}>{t('payments.partnerBillDialog.save')}</Button></div>
    </div>
  </section></div>;
}
